import { applyMiddleware, compose, createStore } from 'redux'
import { useSelector, TypedUseSelectorHook } from 'react-redux'
import { User } from './typings'

type state = {
  sidebarShow: boolean
  sidebarUnfoldable: boolean
  asideShow: boolean
  modalLogout: boolean
  theme: string
  loading: boolean
  role: string
  roles: any
  user: User | null
}

const initialState: state = {
  sidebarShow: true,
  sidebarUnfoldable: false,
  asideShow: false,
  modalLogout: false,
  theme: 'default',
  loading: false,
  role: '',
  roles: [],
  user: null,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type args = { type?: string; [key: string]: any }

const changeState = (state = initialState, { type, ...rest }: args) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(changeState, composeEnhancers(applyMiddleware()))
export default store

// https://react-redux.js.org/using-react-redux/static-typing#typing-the-useselector-hook
export const useTypedSelector: TypedUseSelectorHook<state> = useSelector
